/**
 * business-web's tier configuration — the one way this app reads it
 * (@tonnie/env-schemas/frontend). In a built image from the `/env.js` its
 * container writes at start; on the dev server and in Vitest from
 * `import.meta.env`. The keys it may read are listed in
 * packages/env-schemas/src/frontend/runtime-env-spec.ts.
 *
 * `import.meta.env.PROD` is the literal `true` in a build, so the branch that
 * hands over `import.meta.env` is dropped from the bundle: no value the
 * builder's environment held can be baked through here.
 */
import { createRuntimeEnv } from '@tonnie/env-schemas/frontend';

export const runtimeEnv = createRuntimeEnv(
  'business-web',
  import.meta.env.PROD ? { built: true } : { built: false, devEnv: import.meta.env }
);
